import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { UpdateExternalTeacherBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const updateExternalTeacher = createApiThunk<void, UpdateExternalTeacherBody>(
  "educationalAdvisor/externalTeacher/update",
  async (body, { extra: { educationalAdvisorRepository } }) => {
    await educationalAdvisorRepository!.updateExternalTeacher(body);
  },
);

export const resetUpdateExternalTeacher = createAction("educationalAdvisor/externalTeacher/resetUpdate");
